export const formatCurrency = (value) => {
    // Converte o valor para número, garantindo que não é NaN
    const num = Number(value);
    if (Number.isNaN(num)) {
        return 'R$ 0,00'; // Retorna um valor padrão se a conversão falhar
    }
    // Formata o número para o padrão de moeda brasileira (BRL)
    return new Intl.NumberFormat('pt-BR', { 
        style: 'currency', 
        currency: 'BRL' 
    }).format(num);
};